import React from 'react';
import { CoverSlot } from './CoverSlot';
import { tools, toolsIntro } from '../data/content';
export function Tools() {
  return <section id="bonos" className="bg-ink" data-id="element-210" data-mp="1lfvycdw9s4w7">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-6 lg:py-20" data-id="element-211" data-mp="17ejkc80o6dcy">
        <div className="mx-auto max-w-2xl text-center" data-id="element-212" data-mp="17gmixgfw1eta">
          <h2 className="font-display text-[1.55rem] font-semibold uppercase leading-tight tracking-tight text-ivory sm:text-4xl" data-id="element-213" data-mp="1ceo0fwxo162n">
            <span className="block" data-id="element-214" data-mp="2040i7l726mgk">{toolsIntro.titleLine1}</span>
            <span className="block text-mustard" data-id="element-215" data-mp="243r53dtgsift">{toolsIntro.titleLine2}</span>
          </h2>
          <p className="mx-auto mt-4 max-w-lg font-sans text-base leading-relaxed text-ivory/80" data-id="element-216" data-mp="1qe76mk6x27cb">{toolsIntro.subtitle}</p>
        </div>

        <ul className="mx-auto mt-8 grid max-w-5xl gap-3 md:grid-cols-2 md:gap-4" data-id="element-217" data-mp="1vanvxhpuqrqz">
          {tools.map((tool, index) => <li key={tool.label} className={`flex items-center gap-4 rounded-2xl border border-ink-line bg-ink-raise p-3.5 sm:gap-5 sm:p-4 ${index === tools.length - 1 ? 'md:col-span-2 md:mx-auto md:w-[calc(50%-0.5rem)]' : ''}`} data-id="element-218" data-mp="2j08isbp4m95j" data-mpi={index}>
              <div className="w-[6.25rem] flex-none sm:w-28" data-id="element-219" data-mp="2yrgylj1dp8a8">
                <CoverSlot kicker={tool.label} title={tool.title} image={tool.image} size="xs" data-id="element-220" data-mp="2yt1tj9rlut8m" />
              </div>
              <div className="min-w-0" data-id="element-221" data-mp="2tynwl2xaoe1u">
                <p className="font-sans text-[0.65rem] font-bold uppercase tracking-[0.16em] text-mustard" data-id="element-222" data-mp="38p55f7c9e68r">{tool.label}</p>
                <h3 className="mt-1 font-display text-[1rem] font-semibold uppercase leading-tight text-ivory sm:text-lg" data-id="element-223" data-mp="33ps9lx3etou1">
                  {tool.title}
                </h3>
                <p className="mt-1.5 font-sans text-[0.88rem] leading-snug text-ivory/75" data-id="element-224" data-mp="3cqqiasosmkiy">{tool.description}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}